// API Configuration
// Auto-detect based on hostname
const getApiBaseUrl = (): string => {
  const hostname = window.location.hostname;
  
  console.log('🔍 API URL Detection:', {
    hostname,
    protocol: window.location.protocol,
    href: window.location.href
  });
  
  // If running on production domain, use production API
  if (hostname === 'pos.sparepartponsel.id' || hostname === 'sparepartponsel.id') {
    console.log('✅ Using production API: https://api.sparepartponsel.id/api/v1');
    return 'https://api.sparepartponsel.id/api/v1';
  }
  
  // If served through Cloudflare tunnel (check for HTTPS on non-localhost)
  if (window.location.protocol === 'https:' && hostname !== 'localhost') {
    console.log('✅ Using tunnel API: https://api.sparepartponsel.id/api/v1');
    return 'https://api.sparepartponsel.id/api/v1';
  }
  
  // Use environment variable or fallback to localhost
  const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1';
  console.log('✅ Using local/env API:', apiUrl);
  return apiUrl;
};

export const API_BASE_URL = getApiBaseUrl();

export const PAYMENT_METHODS = {
  CASH: 'CASH',
  TRANSFER: 'TRANSFER',
  QRIS: 'QRIS',
  EDC: 'EDC',
};

export const SALE_STATUS = {
  COMPLETED: 'COMPLETED',
  VOIDED: 'VOIDED',
};

export const USER_ROLES = {
  OWNER: 'OWNER',
  ADMIN: 'ADMIN',
  KASIR: 'KASIR',
};

export const MUTATION_STATUSES = {
  PENDING: 'PENDING',
  CONFIRMED: 'CONFIRMED',
  CANCELLED: 'CANCELLED',
};

export const RETURN_STATUSES = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
};

export const RETURN_TYPES = {
  REFUND: 'REFUND',
  EXCHANGE: 'EXCHANGE',
};

export const RETURN_CONDITIONS = {
  DEFECTIVE: 'DEFECTIVE',
  WRONG_ITEM: 'WRONG_ITEM',
  NOT_AS_DESCRIBED: 'NOT_AS_DESCRIBED',
  CHANGED_MIND: 'CHANGED_MIND',
  OTHER: 'OTHER',
};

export const CUSTOMER_TYPES = {
  RETAIL: 'RETAIL',
  TECHNICIAN: 'TECHNICIAN',
  RESELLER: 'RESELLER',
};

export const MEMBER_STATUS = {
  REGULAR: 'REGULAR',
  GOLD: 'GOLD',
};

export const PRICING_TIERS = {
  NO_DISCOUNT: 'no_discount',
  BRONZE: 'bronze',
  SILVER: 'silver',
  GOLD: 'gold',
  RETAIL_MARKUP: 'retail_markup',
};

export const PRICING_TIER_LABELS = {
  no_discount: 'No Discount (0%)',
  bronze: 'Bronze - 3%',
  silver: 'Silver - 5%',
  gold: 'Gold - 10% Cash / 5% Tempo',
  retail_markup: 'Retail +35%',
};

export const PRICING_TIER_COLORS = {
  no_discount: 'gray',
  bronze: 'orange',
  silver: 'blue',
  gold: 'yellow',
  retail_markup: 'purple',
};

export const PO_STATUS = {
  DRAFT: 'DRAFT',
  SUBMITTED: 'SUBMITTED',
  APPROVED: 'APPROVED',
  RECEIVED: 'RECEIVED',
  CANCELLED: 'CANCELLED',
};

// Legacy exports for backward compatibility
export const API_URL = API_BASE_URL;
export const REPORTS = {
  DAILY_SUMMARY: 'daily_summary',
  STOCK_REPORT: 'stock_report',
  SALES_REPORT: 'sales_report',
};